import Vue from 'vue';

Vue.filter('euro', (str) => `€ ${parseFloat(str).toFixed(2)}`);
